<template>
  <div>
    <div class="user_top_info_holder">
      <div class="profile_holder">
        <div class="profile_image_holder">
          <profile-image
            :platform_module_id="2"
            :image="basicDetails.picture"
            @changingImage="ImageChanged"
          />
        </div>
        <div class="profile_details mt-5 px-4">
          <h4>{{ basicDetails.first_name }} {{ basicDetails.last_name }}</h4>
          <p>
            {{
              basicDetails.roles.length > 0
                ? basicDetails.roles[0].role_name
                : "Not Available"
            }}
          </p>
        </div>
      </div>
      <div class="cover_dp_holder">
        <CoverImage :teacherPersonalDetails="teacherPersonalDetails" @changingImage="ImageChanged" />
      </div>
    </div>
    <div class="user_profile_tabs_holder">
      <vs-tabs>
        <vs-tab label="Account">
          <div>
            <Account
              :teacher_id="teacher_id"
              :teacherPersonalDetails="teacherPersonalDetails"
              :new_activity="new_activity"
              @setAfterUpdate="setAfterUpdate"
            />
          </div>
        </vs-tab>
        <vs-tab label="Profile">
          <div>
            <Profile
              :dynamicfields="dynamicfields"
              :teacherPersonalDetails="teacherPersonalDetails"
              @setAfterUpdate="setAfterUpdate"
              :havePermission="havePermission"
            />
          </div>
        </vs-tab>
        <vs-tab label="Availability">
          <div>
            <Availability
              :availabilityProps="teacherPersonalDetails.availability"
              @setAfterUpdate="setAfterUpdate"
            />
            <holiday

             :havePermission="havePermission('user_holidays')"
              :holidayProps="teacherPersonalDetails.holidays"
              @setAfterUpdate="setAfterUpdate"
              :teacher_id="teacher_id"
            />
          </div>
        </vs-tab>
        <vs-tab label="Courses">
          <div>
            <Courses />
          </div>
        </vs-tab>
        <vs-tab label="Students">
          <div>
            <Students />
          </div>
        </vs-tab>
        <vs-tab label="Payments">
          <div>
            <Payments />
          </div>
        </vs-tab>
        <vs-tab label="Files">
          <div>
            <UserFiles
              :teacher_id="teacher_id"
              :teacherPersonalDetails="teacherPersonalDetails"
              :module_id="2"
            />
          </div>
        </vs-tab>
        <vs-tab label="Connected Apps">
          <ConnectedApps />
        </vs-tab>
      </vs-tabs>
    </div>
  </div>
</template>

<script>
import Account from './components/account/index.vue'
import Profile from './components/profile/index.vue'
import Availability from '@/views/pages/v1/user_profile_settings/components/availability/teacherAvailability.vue'
import holiday from '@/views/pages/v1/user_profile_settings/components/availability/holidays.vue'

import Courses from '@/views/pages/v1/user_profile/components/courses/index.vue'
import Students from '@/views/pages/v1/user_profile/components/students/index.vue'
import Payments from '@/views/pages/v1/user_profile/components/payments/index.vue'
import UserFiles from '@/views/pages/v1/user_profile/components/userfiles/index.vue'
import profileImage from '@/views/pages/v1/user_profile/userPicture'
import CoverImage from '@/views/pages/v1/user_profile/userCoverPicture'
import ConnectedApps from '@/views/pages/v1/user_profile_settings/ConnectedApps'

import { TeacherDetails, TeacherUpdate } from '@/api/teacher'
import { getActivityList } from '@/api/activityLog'


import { GetCountryList } from '@/api/common'
import { fetchCustomStaticFields, fetchCustomFields } from '@/api/customfield'

import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'

export default {
  mixins: [PermissionMiddleware],
  data () {
    return {
      table_name:'staff_list',
      permissions: [],
      teacher_id: '',
      teacherPersonalDetails: {},
      platform_module_id: 38,
      custom_fields: [],
      dynamicform: {},
      dynamicfields: [],
      countryList: [],
      staticChildFields: [],
      staticFields: [],
      basicDetails: {
        roles: []
      },
      new_activity: null,
      schoolAdmin: false,
      editBasicDetails: {
        first_name: '',
        last_name: '',
        city: '',
        platform_customer_countries_id: '',
        address1: '',
        address2: '',
        state: '',
        zip: '',
        email: '',
        phone: '',
        user_roles_id: ''
      }
    }
  },
  components: {
    profileImage,
    Account,
    Profile,
    Availability,
    Courses,
    Students,
    Payments,
    UserFiles,
    holiday,
    CoverImage,
    ConnectedApps
  },
  created () {
    const role_permission = localStorage.getItem('role_permission')
    if (role_permission === 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Teachers')
    }
  },
  mounted () {
    this.teacher_id = JSON.parse(localStorage.getItem('userInfo')).id

    this.fetchTeacherDetails(this.teacher_id)
    this.getLastActivity()
    this.fetchCountry()
    this.fetch_field_list()
  },
  methods: {
    havePermission (module) {
      const modules = this.permissions
      const getIndex = modules.findIndex(
        (item) => item.platform_sub_module.sub_module_table === module
      )
      if (getIndex === -1) {
        return false
      } else {
        return true
      }
    },
    async getLastActivity () {
      const payload = {
        customer_id: localStorage.getItem('customer_id'),
        entity_id: this.teacher_id,
        platform_module_id: 2
      }

      try {
        const response = await getActivityList(payload)
        this.new_activity = response.data.data.activity
      } catch (e) {
        console.log(e)
      }
    },
    setAfterUpdate (data) {
      this.teacherPersonalDetails = data.data.operationalUser

      this.basicDetails = this.teacherPersonalDetails.basic_details
      if (this.teacherPersonalDetails.address.length === 0) {
        this.teacherPersonalDetails.address = [
          {
            address1: '',
            address2: '',
            city: '',
            id: '',
            state: '',
            zip: ''
          }
        ]
      }
      if (this.teacherPersonalDetails.phone.length > 0) {
        const temm = this.teacherPersonalDetails.phone
        temm.map((item) => {
          if (item.default === '1') {
            item.default = 1
          } else {
            item.default = 0
          }
        })
        this.teacherPersonalDetails.phone = temm
      }
      if (this.teacherPersonalDetails.email.length > 0) {
        const temm_ = this.teacherPersonalDetails.email
        temm_.map((item) => {
          if (item.default === '1') {
            item.default = 1
          } else {
            item.default = 0
          }
        })
        this.teacherPersonalDetails.email = temm_
      }
      if (this.teacherPersonalDetails.availability.length === 0) {
        this.teacherPersonalDetails.availability = []
      }


      this.editBasicDetails.first_name =
        this.teacherPersonalDetails.basic_details.first_name
      this.editBasicDetails.last_name =
        this.teacherPersonalDetails.basic_details.last_name
      this.editBasicDetails.email = this.basicDetails.email.email
      this.editBasicDetails.phone = this.basicDetails.phone.phone
      this.editBasicDetails.city = this.basicDetails.address.city
      this.editBasicDetails.state = this.basicDetails.address.state
      this.editBasicDetails.address1 = this.basicDetails.address.address1
      this.editBasicDetails.address2 = this.basicDetails.address.address2
      this.editBasicDetails.zip = this.basicDetails.address.zip
      this.editBasicDetails.platform_customer_countries_id =
        this.basicDetails.address.platform_customer_countries_id
      this.editBasicDetails.user_roles_id =
        this.basicDetails.roles[0].user_role_id

      if (
        this.teacherPersonalDetails.payout &&
        'per_hour_payment' in this.teacherPersonalDetails.payout
      ) {
        this.payout = this.teacherPersonalDetails.payout
      }

      this.permissions =
        this.teacherPersonalDetails.basic_details.UserOrganisationMapping[0].role_sub_modules
    },
    async ImageChanged (imageUrl, type) {
      try {
        const language = this.teacherPersonalDetails.languages
        const __temp = language.map((item) => {
          return item.id
        })
        const finalLanguages = {
          platform_languages_id: __temp
        }
        const payload = {}
        if (type === 'Profile') {
          payload.updateField = {
            picture: imageUrl

          }
        } else {
          payload.updateField = {
            cover_picture: imageUrl
          }
        }
        const customer_id = localStorage.getItem('customer_id')
        // if (finalLanguages.platform_languages_id.length > 0) {
        //   payload.updateField.languages = finalLanguages
        // }
        const { data } = await TeacherUpdate(
          payload,
          this.teacher_id,
          customer_id
        )

        this.teacherPersonalDetails = data.data.operationalUser
        if (this.teacherPersonalDetails.address.length === 0) {
          this.teacherPersonalDetails.address = [
            {
              address1: '',
              address2: '',
              city: '',
              id: '',
              state: '',
              zip: ''
            }
          ]
        }
        if (this.teacherPersonalDetails.phone.length > 0) {
          const temm = this.teacherPersonalDetails.phone
          temm.map((item) => {
            if (item.default === '1') {
              item.default = 1
            } else {
              item.default = 0
            }
          })
          this.teacherPersonalDetails.phone = temm
        }
        if (this.teacherPersonalDetails.email.length > 0) {
          const temm_ = this.teacherPersonalDetails.email
          temm_.map((item) => {
            if (item.default === '1') {
              item.default = 1
            } else {
              item.default = 0
            }
          })
          this.teacherPersonalDetails.email = temm_
        }
        if (this.teacherPersonalDetails.availability.length === 0) {
          this.teacherPersonalDetails.availability = []
        }

        this.firstNameedit = false
        this.lastNameEdit = false
        this.basicDetails = this.teacherPersonalDetails.basic_details
        this.$vs.notify({
          title: 'Updated',
          text: 'Staff Updated Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
        const userInfo = JSON.parse(localStorage.getItem('userInfo'))
        if (userInfo.picture !== this.teacherPersonalDetails.basic_details.picture) {
          userInfo.picture = this.teacherPersonalDetails.basic_details.picture
          localStorage.setItem('userInfo', JSON.stringify(userInfo))
          window.location.reload()
        }
      } catch (e) {
        this.$vs.notify({
          title: 'Error',
          text: e.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
      //
    },
    async fetch_field_list () {
      try {
        const customerId = this.$store.getters.customerId
        const { data } = await fetchCustomStaticFields(38, customerId, {table_name:this.table_name})
        //

        this.staticFields = data.data.module_fields
        this.staticChildFields = data.data.module_child_fields

        //
      } catch (e) {
        //
      }
    },
    async fetchCountry () {
      try {
        const { data } = await GetCountryList()
        this.countryList = data.data.countries_list
      } catch (e) {
        //
      }
    },
    async fetchTeacherDetails (teacher_id) {
      try {
        const customer_id = this.$store.getters.customerId
        const { data } = await TeacherDetails(teacher_id, customer_id)

        this.teacherPersonalDetails = data.data.operationalUser
        if (this.teacherPersonalDetails.address.length === 0) {
          this.teacherPersonalDetails.address = [
            {
              address1: '',
              address2: '',
              city: '',
              id: '',
              state: '',
              zip: ''
            }
          ]
        }
        if (this.teacherPersonalDetails.phone.length > 0) {
          const temm = this.teacherPersonalDetails.phone
          temm.map((item) => {
            if (item.default === '1') {
              item.default = 1
            } else {
              item.default = 0
            }
          })
          this.teacherPersonalDetails.phone = temm
        }
        if (this.teacherPersonalDetails.email.length > 0) {
          const temm_ = this.teacherPersonalDetails.email
          temm_.map((item) => {
            if (item.default === '1') {
              item.default = 1
            } else {
              item.default = 0
            }
          })
          this.teacherPersonalDetails.email = temm_
        }
        if (this.teacherPersonalDetails.availability.length === 0) {
          this.teacherPersonalDetails.availability = []
        }
        this.basicDetails = this.teacherPersonalDetails.basic_details

        this.editBasicDetails.first_name =
          this.teacherPersonalDetails.basic_details.first_name
        this.editBasicDetails.last_name =
          this.teacherPersonalDetails.basic_details.last_name
        this.editBasicDetails.email = this.basicDetails.email.email
        this.editBasicDetails.phone = this.basicDetails.phone
          ? this.basicDetails.phone.phone
          : ''
        this.editBasicDetails.city = this.basicDetails.address.city
        this.editBasicDetails.state = this.basicDetails.address.state
        this.editBasicDetails.address1 = this.basicDetails.address.address1
        this.editBasicDetails.address2 = this.basicDetails.address.address2
        this.editBasicDetails.zip = this.basicDetails.address.zip
        this.editBasicDetails.platform_customer_countries_id =
          this.basicDetails.address.platform_customer_countries_id
        this.editBasicDetails.user_roles_id =
          this.basicDetails.roles[0].user_role_id

        if (
          this.teacherPersonalDetails.payout &&
          'per_hour_payment' in this.teacherPersonalDetails.payout
        ) {
          this.payout = this.teacherPersonalDetails.payout
        }

        this.permissions =
          this.teacherPersonalDetails.basic_details.UserOrganisationMapping[0].role_sub_modules
      } catch (e) {
        console.warn(e)
      } finally {
        this.fetchCustomField()
      }
    },
    async fetchCustomField () {
      try {
        const customerId = this.$store.getters.customerId
        const { data } = await fetchCustomFields('Staff', customerId)

        this.custom_fields = data.data.custom_fields

        for (let i = 0; i < this.custom_fields.length; i++) {
          if (
            this.custom_fields[i].inputtype === 'checkbox' ||
            this.custom_fields[i].inputtype === 'multiselect'
          ) {
            let temp = []
            if (this.teacherPersonalDetails[this.custom_fields[i].field]) {
              temp = this.teacherPersonalDetails[this.custom_fields[i].field]
            }
            this.$set(this.dynamicform, this.custom_fields[i].field, temp)
            //
          } else {
            this.dynamicform[this.custom_fields[i].field] =
              this.teacherPersonalDetails[this.custom_fields[i].field]
          }
        }

        const dynamicfieldsarr = data.data.custom_fields.map((item) => {
          const container = {}
          container['name'] = item.label
          container['field'] = item.field
          container['is_collection'] = item.is_collection
          container['inputtype'] = item.inputtype
          return container
        })

        //
        this.dynamicfields = dynamicfieldsarr
      } catch (e) {
        console.warn(e)
      }
    }
  }
}
</script>
<style>
.cover_dp_holder .edit_holder {
  position: relative;
}

.cover_dp_holder .edit_holder input {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index:1;
  opacity: 0;
}
</style>
